import React, { useState } from "react";
import toast from "react-hot-toast";
import { useUpdatePaperMachineApi } from "../../hooks/machine/useUpdatePaperMachineApi";
import { useCommonStore } from "../../store";

const UpdateMachine = ({ data, setIsModalOpen }: any) => {
  const [numberPaper, setNumberPaper] = useState<any>();
  const { reload, setReload } = useCommonStore();
  const { mutate: $updatePaperMachine } = useUpdatePaperMachineApi();

  const handleUpdate = async () => {
    if (numberPaper > 700) {
      toast.error("Number of printed papers must be less than 700 !");
      return;
    }
    $updatePaperMachine(
      {
        machine_id: data?.userId,
        paper_number: +numberPaper,
      },
      {
        onSuccess: (res: any) => {
          if (res?.code === 200) {
            toast.success(res?.message);
            setIsModalOpen(false);
            setReload(!reload);
            return;
          } else {
            toast.error(res?.message);
            setIsModalOpen(false);
            return;
          }
        },
        onError: (error: any) => {
          toast.error("Update Paper Machine failure");
          setIsModalOpen(false);
          return;
        },
      }
    );
  };
  return (
    <div className="flex flex-col">
      <div className="flex flex-col gap-2">
        <div className="flex flex-col">
          <small>Name:</small>
          <div className="p-[6px] border-[1px] border-gray-200 rounded-md ">
            <span>{data?.userName}</span>
          </div>
        </div>
        <div className="flex flex-col">
          <small>Number Paper:</small>
          <input
            onChange={(e) => {
              setNumberPaper(e.target.value);
            }}
            type="number"
            className="p-[6px] border-[1px] border-gray-200 rounded-md outline-none"
          ></input>
        </div>
      </div>
      <div className="w-full flex items-center justify-end mt-4">
        <div
          onClick={handleUpdate}
          className="xl:px-[18px] lg:w-[30%] w-full xl:py-[6px] px-[14px] py-[5px] rounded-full bg-photo-time-pink-main flex justify-center items-center cursor-pointer"
        >
          <span className="text-sm text-white">Update</span>
        </div>
      </div>
    </div>
  );
};

export default UpdateMachine;
